<!-- Header -->
<div class="modal-header sticky-header d-flex justify-content-between align-items-center">
  <h5 class="modal-title" id="permissionModalLabel"> {{ lotOrHipText }} {{ catalogData?.horse.lot }} - Review and Proceed</h5>
  <div>
    <button type="button" class="btn col-auto me-2 btn-secondary" (click)="modal.dismiss('Cross click')">Close</button>
    <button type="button" class="btn col-auto btn-primary"  [disabled]="isConfirmDisabled" (click)="OnConfirmation()">Confirm & Proceed</button>
  </div>
 
</div>

<!-- Body -->
<div class="modal-body">
  <div class="row justify-content-center" style="padding-left:0.8rem;padding-right:0.8rem;" *ngIf="isAcknowledgementsSectionEnabled">
    <div  [ngClass]="{'col-auto' :  acknowledgments?.horseStudies?.length == 1, 'col-8': acknowledgments?.horseStudies?.length > 1}">

      <!-- Alerts -->
      <!-- X-Ray Images Submitted -->
      <div *ngIf="acknowledgments?.draftAcknowledgments?.isLotHasXrayImagesSubmitted"
           class="custom-alert d-flex align-items-center justify-content-between">
        <span class="d-flex align-items-center">
          <i class="fa fa-exclamation-triangle me-2 text-warning"></i>
          This lot already has X-Ray Images submitted
        </span>
        <mat-checkbox class="green-checkbox d-flex flex-column align-items-center"
                      [(ngModel)]="isLotHasXrayImagesSubmittedAcknowledged">
          <span class="fw-bold text-dark mt-1">Acknowledged</span>
        </mat-checkbox>
      </div>

      <!-- Scope Video Submitted -->
      <div *ngIf="acknowledgments?.draftAcknowledgments?.isLotHasScopeVideoSubmitted"
           class="custom-alert d-flex align-items-center justify-content-between">
        <span class="d-flex align-items-center">
          <i class="fa fa-exclamation-triangle me-2 text-warning"></i>
          This lot already has a Scope Video submitted
        </span>
        <mat-checkbox class="green-checkbox d-flex flex-column align-items-center"
                      [(ngModel)]="isLotHasScopeVideoSubmittedAcknowledged">
          <span class="fw-bold text-dark mt-1">Acknowledged</span>
        </mat-checkbox>
      </div>

      <!-- Study Uploaded to Different Lot -->
      <div *ngIf="acknowledgments?.draftAcknowledgments?.isStudyUploadedToDifferentLot"
           class="custom-alert d-flex align-items-center justify-content-between">
        <span class="d-flex align-items-center">
          <i class="fa fa-exclamation-triangle me-2 text-warning"></i>
          You have already submitted data in this study to a different Lot
        </span>
        <mat-checkbox class="green-checkbox d-flex flex-column align-items-center"
                      [(ngModel)]="isStudyUploadedToDifferentLotAcknowledged">
          <span class="fw-bold text-dark mt-1">Acknowledged</span>
        </mat-checkbox>
      </div>

        <!-- Scope Video encoding errors -->
        <div *ngIf="acknowledgments?.mediaConversionErrors?.length > 0"
          class="custom-alert d-flex flex-column"
          #section>
     
       <!-- Warning Message Row -->
       <div class="d-flex align-items-center">
         <i class="fa fa-exclamation-triangle me-2 text-warning"></i>
         <span>
          Submission cannot proceed due to potential issues with one or more media files. Please review your videos
           <span class="text-warning" style="cursor: pointer;" (click)="section.dataset.expanded = section.dataset.expanded === 'true' ? 'false' : 'true'">
            <i class="fa fa-lg" style="width: 14px;" [ngClass]="section.dataset.expanded === 'true' ? 'fa-caret-down' : 'fa-caret-right'">
            </i> Review
           </span>
         </span>         
       </div>     
     
       <!-- Expandable Errors -->
       <div *ngIf="section.dataset.expanded === 'true'" class="mt-3 ps-3">     
         <div *ngFor="let error of acknowledgments?.mediaConversionErrors">     
           <div *ngIf="!error.isSuccess" class="mb-2">     
             <div class="text-danger">{{ error.mediaFileName }}</div>
     
             <div class="text-muted small">{{ error.message }}</div>     
           </div>     
         </div>     
       </div>     
     </div>
    </div>
    <hr/>
  </div>
  



  <p class="text-center mt-4" style="font-size:16px;">
    Before proceeding please review the submission is for the correct Lot
  </p>

  <!-- Comparison Table -->
  <div class="table-responsive data-grid p-0">
    <table class="mat-table cdk-table mat-sort table table-hover table-hover">
      <thead>
        <tr class="mat-header-row">
          <th></th>
          <th>Catalogue Data</th>
          <th *ngFor="let hs of acknowledgments?.horseStudies; let i = index">
            <span *ngIf="i == 0">Your Uploaded Data </span> 
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ lotOrHipText }}</td>
          <td>{{ catalogData?.horse.lot }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies"></td>
        </tr>
        <tr>
          <td>Accession Number</td>
          <td>{{ catalogData?.horse.accessionCode }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies">{{ hs.accessionNumber }}</td>
        </tr>
        <tr>
          <td>Microchip Number</td>
          <td>
            {{
              catalogData?.horse.microchip ||
              'N/A'
            }}
          </td>
          <td *ngFor="let hs of acknowledgments?.horseStudies">{{ hs.microchipNumber }}</td>
        </tr>
        <tr>
          <td>Type</td>
          <td>{{ catalogData?.horse.horseAgeCategoryName }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies">{{hs.age}}</td>
        </tr>
        <tr>
          <td>Horse Name</td>
          <td>{{ catalogData?.horse.name }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies">{{ hs.horseName }}</td>
        </tr>
        <tr>
          <td>Sire</td>
          <td>{{ catalogData?.horse.sireDisplay }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies"></td>
        </tr>
        <tr>
          <td>Dam</td>
          <td>{{ catalogData?.horse.dam }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies"></td>
        </tr>
        <tr>
          <td>Consignor</td>
          <td>{{ catalogData?.horse.consignorName }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies">{{ hs.consignor }}</td>
        </tr>
        <tr>
          <td>Study Date</td>
          <td></td>
          <td *ngFor="let hs of acknowledgments?.horseStudies">
            {{ hs.studyDateTime | date: dateFormat }}
          </td>
        </tr>
        <tr>
          <td>Sale Name</td>
          <td>{{ catalogData?.horse.saleName }}</td>
          <td *ngFor="let hs of acknowledgments?.horseStudies"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


